import React from 'react';
import { services } from './data';
import './Syles/Services.scss';

const Services=()=>{
    return(
        <div className="home-services">
            <h1>HostDesign products</h1>
            <p className="sub">You can use Hostdesign unlimited for free, and if you want you can support us with coffee and help us make Hostdesign even better product.</p>
            <ul>
                {services.map((list) =>{
                    return(
                        <li>
                            <div className="circle" style={{ backgroundImage: `url(${list.BackgroundImage})` }}>

                            {list.icon}
                            </div>
                            <h2>{list.title}</h2>
                            <p>{list.desc}</p>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
};
export default Services ;